<template>
  <div class="reading-history-page">
    <div class="page-header">
      <h1>
        <svg class="title-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
        阅读进度
      </h1>
      <p>继续上次的阅读，追更不迷路</p>
    </div>

    <div v-if="loading" class="loading-state">
      <div class="loading-spinner"></div>
      <p>加载中...</p>
    </div>

    <div v-else-if="history.length === 0" class="empty-state">
      <svg class="empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
      <p>还没有阅读记录</p>
      <button @click="goHome" class="btn-primary">去首页看看</button>
    </div>

    <div v-else class="history-list">
      <div v-for="item in history" :key="item.comic_id" class="history-card">
        <img :src="item.cover || '/logo.png'" class="history-cover" alt="封面" />
        <div class="history-info">
          <h3 class="history-title">{{ item.comic_title }}</h3>
          <p class="history-chapter">读至：{{ item.chapter_title || '未知章节' }}</p>
          <p class="history-page">第 {{ item.current_page }} / {{ item.total_pages || '?' }} 页</p>
          <p class="history-time">{{ item.updatetime_text }}</p>
        </div>
        <div class="history-actions">
          <button @click="continueReading(item)" class="btn-primary">继续阅读</button>
          <button @click="deleteItem(item.comic_id)" class="btn-secondary">删除</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getReadingHistory, deleteReadingProgress } from '../api/index';

export default {
  name: 'ReadingHistoryPage',
  data() {
    return {
      loading: true,
      history: []
    };
  },
  mounted() {
    this.loadHistory();
  },
  methods: {
    async loadHistory() {
      this.loading = true;
      try {
        const res = await getReadingHistory({ page: 1, limit: 50 });
        if (res.data && res.data.code === 1) {
          this.history = res.data.data.list || [];
        }
      } catch (e) {
        console.error('加载阅读历史失败:', e);
      } finally {
        this.loading = false;
      }
    },

    continueReading(item) {
      this.$router.push(`/reader/${item.chapter_id}/${item.comic_id}`);
    },

    async deleteItem(comicId) {
      if (!confirm('确定要删除这条阅读记录吗？')) return;
      try {
        const res = await deleteReadingProgress(comicId);
        if (res.data && res.data.code === 1) {
          this.history = this.history.filter(item => item.comic_id !== comicId);
        }
      } catch (e) {
        console.error('删除阅读记录失败:', e);
        alert('删除失败');
      }
    },

    goHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
.reading-history-page {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 18px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  color: var(--text);
}

.page-header {
  text-align: center;
  margin-bottom: 24px;
  padding: 22px 24px;
  background: linear-gradient(135deg, var(--brand-deep) 0%, var(--brand) 100%);
  color: #fff;
  border-radius: 8px;
}

.page-header h1 {
  margin: 0 0 8px 0;
  font-size: 22px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.page-header p {
  margin: 0;
  opacity: 0.9;
  font-size: 13px;
}

.title-svg {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}

.loading-state,
.empty-state {
  text-align: center;
  padding: 50px 20px;
  color: var(--text-dim);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--surface-3);
  border-top-color: var(--brand);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.empty-icon {
  width: 56px;
  height: 56px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.history-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.history-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 8px;
  transition: all 0.3s ease;
}

.history-card:hover {
  border-color: var(--brand);
  transform: translateY(-1px);
}

.history-cover {
  width: 80px;
  height: 106px;
  object-fit: cover;
  border-radius: 5px;
  flex-shrink: 0;
}

.history-info {
  flex: 1;
  min-width: 0;
}

.history-title {
  margin: 0 0 6px 0;
  font-size: 16px;
  color: var(--text);
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.history-chapter,
.history-page,
.history-time {
  margin: 0 0 3px 0;
  font-size: 12px;
  color: var(--text-dim);
}

.history-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.btn-primary {
  background: var(--brand);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background: var(--brand-hover);
  transform: translateY(-1px);
}

.btn-secondary {
  background: var(--surface-3);
  color: var(--text);
  border: 1px solid var(--border);
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background: var(--brand-soft);
  border-color: var(--brand);
}

@media (max-width: 768px) {
  .reading-history-page {
    margin: 10px;
    padding: 15px;
  }

  .history-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .history-actions {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
